import './GameCard.scss';

const GameCard = (props) => {
    return (
        <div className="GameCard">
            <div className="card border-0">
                <div className="gamecard-img-container">
                    <img src={props.thumbnail} className="card-img-top" loading="lazy" alt={props.title} />
                </div>    
                <div className="row my-2">
                    <div className="col-8">
                        <h5 className="card-title"><small>{props.title}</small></h5>
                    </div>
                    <div className="col-4">
                        <p><i className="fas fa-star text-warning" /> {props.rating}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GameCard;
